(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mh-samples"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mhSamplesQuickAddInit) return;
  window.__mhSamplesQuickAddInit = true;

  function sampleLinks() { return Array.prototype.slice.call(document.querySelectorAll('.mh-sample[data-mh-variant]')); }
  function sampleVariantIds() { return sampleLinks().map(function (a) { return a.getAttribute('data-mh-variant'); }); }
  function variantId(link) { return link.getAttribute('data-mh-variant') || null; }
  function discountCode(link) { return link.getAttribute('data-mh-discount') || ''; }
  function openCartDrawer() { var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer'); if (d && typeof d.show === 'function') { d.show(); return true; } return false; }

  // One sample per order: when a sample is in the cart, disable the others.
  function setClaimState(claimedId) {
    sampleLinks().forEach(function (a) {
      var btn = a.querySelector('.mh-sample__btn');
      if (btn && !a.dataset.origLabel) a.dataset.origLabel = btn.textContent;
      if (claimedId) {
        a.classList.add('is-claimed');
        a.setAttribute('aria-disabled', 'true');
        if (btn) btn.textContent = (a.getAttribute('data-mh-variant') === claimedId) ? 'In basket \u2713' : (a.dataset.origLabel || btn.textContent);
      } else {
        a.classList.remove('is-claimed');
        a.setAttribute('aria-disabled', 'false');
        if (btn && a.dataset.origLabel) btn.textContent = a.dataset.origLabel;
      }
    });
  }
  function refreshClaimState() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = sampleVariantIds(); var found = null;
        (cart.items || []).forEach(function (it) { if (ids.indexOf(String(it.variant_id)) > -1) found = String(it.variant_id); });
        setClaimState(found); return found;
      }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshClaimState);
  else refreshClaimState();
  document.addEventListener('cart:updated', function () { refreshClaimState(); });

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.mh-sample') : null;
    if (!link) return;
    if (link.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; } // one per order

    var id = variantId(link);
    if (!id || !window.theme || !theme.pubsub || !theme.routes) return; // no framework: let href navigate (discount link or /cart/add)

    e.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');

    var code = discountCode(link);
    var pre = code ? fetch('/discount/' + encodeURIComponent(code), { headers: { 'Accept': 'text/html' } }).catch(function () {}) : Promise.resolve();

    pre.then(function () {
      var sectionsToBundle = [];
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })); } catch (err) {}
      return fetch((theme.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, sections: sectionsToBundle, sections_url: window.location.pathname })
      });
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status && Number(state.status) >= 400) { window.location.href = link.getAttribute('href'); return; }
        var addedSections = state && state.sections;
        return fetch((theme.routes.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (fullCart) {
            if (addedSections) fullCart.sections = addedSections;
            try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'mh-samples', cart: fullCart }); } catch (err) {}
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: fullCart } }));
            setClaimState(id);
            if (!openCartDrawer()) { window.location.href = theme.routes.cart_url || '/cart'; }
          });
      })
      .catch(function () { window.location.href = link.getAttribute('href'); })
      .then(function () { link.removeAttribute('aria-busy'); });
  }, false);
})();

  } catch(e) { console.error(e); }
})();
})();
